// 基础 js 依赖库, 仅供 admin.js 和 application.js 共享使用
import 'bootstrap/dist/js/bootstrap';
import 'selectize';


import $ from 'jquery';
window.jQuery = $;
window.$ = $;

// require("@fancyapps/fancybox"); // Import fancybox
require('@fancyapps/fancybox/dist/jquery.fancybox.min'); // Import fancybox

import('@rails/ujs').then( ujs => ujs.start() )
import('turbolinks').then( turbolinks => turbolinks.start() )
import('@rails/activestorage').then( activestorage => activestorage.start() )
import 'channels'
// import 'slick-carousel/slick/slick.min'
// import 'slick-carousel/slick/slick.css'
// import 'slick-carousel/slick/slick-theme.css'
import Swiper from 'swiper';
import ClipboardJS from './clipboard.min';
window.ClipboardJS = ClipboardJS;
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context('images', true)
const imagePath = (name) => images(name, true)

// const slickCarouselInit = () => {
//   $('.slick-carousel').slick({
//     autoplay: true,
//     dots: true,
//     infinite: true,
//     speed: 500,
//     fade: true,
//     cssEase: 'linear',
//     responsive: true,
//     adaptiveHeight: true
//   });
// }


// $(document).on('turbolinks:load', function () {
  // slickCarouselInit();
// })

$(document).on('ready turbolinks:load', function() {
  $('[data-toggle="tooltip"]').tooltip()

  var swiper = new Swiper('.swiper-container', {
    direction: 'horizontal',
    // slidesPerGroup: 0,
    slidesPerView: 'auto',
    centeredSlides: true,
    // autoHeight: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    lazy: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
      // type: 'fraction',
      // renderFraction: function (currentClass, totalClass) {
      //   return '<span class="' + currentClass + '"></span>' +
      //     ' / ' +
      //     '<span class="' + totalClass + '"></span>';
      // }
    },
  });

  // Slick Carousel
  // slickCarouselInit();

  // FancyBox configrations
  // 完全禁用 hash 功能，避免打开预览时改变路由
  $.fancybox.defaults.hash = false;
  $("[data-fancybox]").fancybox({
    loop: true,
    hash: false,
    beforeLoad: function() {
      // 打开前禁用 Turbolinks
      if (window.Turbolinks) {
        window.Turbolinks.controller.stop();
      }
    },
    beforeShow: function () {
      // console.info(this); //Current object
      // console.info(this.element); //Group
      // console.info(this.group); // Element (link)
      // console.info(this.index); // Element index in the group
      if (!!swiper && swiper.slideTo && swiper.slides && swiper.slides.length > 0) {
        swiper.slideTo(this.index, false, false);
      }
    },
    afterShow: function () {
      // 先移除可能已存在的旧按钮容器
      $('.fancybox-inner .fancybox-buttons-container').remove();

      // 创建按钮容器
      var buttonsContainer = $('<div class="fancybox-buttons-container"></div>');

      // 1. 获取并添加联系按钮
      var contactBtn = $('.sticky-btn .contact-btn').first().clone();
      if (contactBtn.length && contactBtn.attr('href')) {
        contactBtn.removeAttr('class');
        contactBtn.addClass('fancybox-btn fancybox-btn-contact');
        buttonsContainer.append(contactBtn);
      }

      // 2. 获取并添加返回首页按钮
      var homeBtn = $('.sticky-btn .home-btn').first().clone();
      if (homeBtn.length && homeBtn.attr('href')) {
        homeBtn.removeAttr('class');
        homeBtn.addClass('fancybox-btn fancybox-btn-home');
        buttonsContainer.append(homeBtn);
      }

      // 3. 获取并添加查看同类房源按钮
      var similarBtn = $('.sticky-btn .similar-btn').first().clone();
      if (similarBtn.length && similarBtn.attr('href')) {
        similarBtn.removeAttr('class');
        similarBtn.addClass('fancybox-btn fancybox-btn-similar');
        buttonsContainer.append(similarBtn);
      }

      // 4. 添加返回楼盘信息按钮（最右边）
      var propertyInfoBtn = $('<a class="fancybox-btn fancybox-btn-property-info" href="javascript:void(0);">返回楼盘信息</a>');
      propertyInfoBtn.on('click', function () {
        $.fancybox.close();
      });
      buttonsContainer.append(propertyInfoBtn);

      $('.fancybox-inner').append(buttonsContainer);
    },
    afterClose: function() {
      // 关闭后恢复 Turbolinks
      if (window.Turbolinks) {
        window.Turbolinks.controller.start();
      }
    }
  });
});
